<template>
  <div class="input-box">
    <div>
      <label>
        <p>タイトルを入力 (14文字)</p>
        <input 
        type="text" 
        maxlength="14"
        v-model="inputTitle"
        value="">
      </label>
    </div>
    <div class="input-box-btns">
      <button @click="cancel">キャンセル</button>
      <button @click="newShioriTitle">決定</button>
    </div>
  </div>
</template>


<script>
  
export default {
  data() {
    return {
      inputTitle: "",
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
      this.inputTitle = "";
    },
    newShioriTitle() {
      this.$emit('new-shiori-title', this.inputTitle);
    }
  }
}
</script>
